import { UserInfo } from '@/domains/appShell/types/user.type'
import { UserInfoRole } from '@/domains/appShell/types/userRole.type'

import { atom } from 'jotai'

export const userAtom = atom<UserInfo | undefined>(undefined)

/**
 * Derived atom to check if the current user is an admin
 */
export const isAdminAtom = atom(get => {
  const user = get(userAtom)
  return user?.role === UserInfoRole.ADMIN
})

/**
 * Jotai atom handling user permissions, with an optional role check.
 * @returns Object holding hasPermission
 */
export const userPermissionsAtom = atom(get => {
  const user = get(userAtom)

  /**
   * Checks whether the user has a permission, for one or several roles.
   * @param permission - Permission to check
   * @param roles - Required role(s) (undefined = any role accepted)
   * @returns true if the permission is granted
   */
  const hasPermission = (permission: string, roles?: UserInfoRole | UserInfoRole[]): boolean => {
    if (!user) return false

    // Check that the user has the permission
    if (!user.permissions.includes(permission)) return false

    // No role given: every role is accepted
    if (roles === undefined) return true

    // A single role given
    if (!Array.isArray(roles)) {
      return user.role === roles
    }

    // Several roles given
    return roles.includes(user.role)
  }

  return { hasPermission }
})
